<app-settings-left-nav></app-settings-left-nav>
<router-outlet></router-outlet>

